module.exports = __webpack_public_path__ + "static/img/icon-qq.a526500e.png";